<template>
  <div>
    <vk-button @click="show=true" class="menu-button">
      <label class="hamburger-icon"><span></span></label>
      <span>メニュー</span>
    </vk-button>

    <vk-offcanvas overlay :show.sync="show">
      <vk-offcanvas-close @click="show=false"></vk-offcanvas-close>
      <router-link to="/">
        <img class="logo" src="../../assets/img/harigulogo.svg" alt="" width="250">
      </router-link>
      <h3>メニュー</h3>
      <div>
        <hr>
        <div>
          <router-link :to="{path:'/contents/info'}" @click.native="show=false">お知らせ</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/h/favorite/'}" @click.native="show=false">お気に入り一覧</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/h/popular/'}" @click.native="show=false">人気一覧</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/h/category/'}" @click.native="show=false">カテゴリ一覧</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/h/searchHistory/'}" @click.native="show=false">検索履歴</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/contribution'}" @click.native="show=false">リクエスト</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/contents/how-to-paste'}" @click.native="show=false">貼り方</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/contents/question'}" @click.native="show=false">よくある質問</router-link>
        </div>
        <hr>
        <div>
          <router-link :to="{path:'/contents/contact'}" @click.native="show=false">お問い合わせ</router-link>
        </div>
      </div>
    </vk-offcanvas>
  </div>
</template>


<script>
  export default {
    name: 'AppMenu',
    components: {},
    data () {
      return {
        show: false
      };
    },
    computed: {},
    methods: {}
  };
</script>

<style scoped lang="scss">
  .logo {
    margin-bottom: 1rem;
  }
  .menu-button {
    background-color: #fff;
    color: #666;
    border-radius: 10px;
    padding: 0;
    width: 6rem;
    .hamburger-icon {
      width: 24px;
    }
    .hamburger-icon span,.hamburger-icon span:before,.hamburger-icon span:after{
      position: absolute;
      height: 3px;/*線の太さ*/
      width: 20px;/*長さ*/
      background: #888;
      display: block;
      content: '';
      cursor: pointer;
    }

    .hamburger-icon span:before {
      bottom: 6px;
    }
    .hamburger-icon span:after {
      bottom: -6px;
    }
  }

</style>
<style lang="scss">
  #layout-header .uk-offcanvas-bar {
    background-color: #888888;
    background: linear-gradient(-90deg, #999999, #666666);
    h3, a, button.uk-close {
      color: #ffffff;
    }
    padding-top: 3rem;
  }

</style>
